import styled, {css} from "styled-components"
import BrandAvatar from "@irati/ui/src/BrandAvatar"
import Flex from "@irati/ui/src/Flex"

export const StyledItemAvatar = styled(BrandAvatar)`
  max-width: none;

  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.tablet`
      width: 96px;
      height: 96px;
    `}
  `}
`

export const BalanceLeft = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${({theme}) => theme.spacing.oneAndHalf};
  margin-top: ${({theme}) => theme.spacing.two};
  background-color: ${({theme}) => theme.colors.greys.graphGrey};
  align-items: center;
`

export const MobileFlex = styled(Flex)`
  flex-direction: column;
  background-color: white;
  width: 100%;
  padding: ${(context) => context.theme.spacing.two};
`
